import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { getShopperToken, getVeyaTeamToken } from "../../lib/api";

export default function RequireShopperAuth({ children }) {
  const location = useLocation();
  const token = getShopperToken();
  const veyaTeamToken = getVeyaTeamToken();

  if (!token && !veyaTeamToken) {
    return (
      <Navigate
        to="/login"
        replace
        state={{ from: location.pathname }}
      />
    );
  }

  return children;
}